// Apolo IDE — live context-usage for the composer drop-up. Subscribes to the
// per-session run store (same source the chat reads) and recomputes the
// conversation footprint as messages stream in. useState+subscribe (not
// useSyncExternalStore) because getRunSnapshot returns a fresh object each call.

import { useEffect, useMemo, useState } from 'react';
import { getRunSnapshot, subscribeRun } from '../lib/agentRunStore.js';
import { computeContextUsage } from '../lib/contextUsage.js';

export default function useContextUsage(sessionId, model) {
  const [snap, setSnap] = useState(() => getRunSnapshot(sessionId));
  useEffect(() => {
    setSnap(getRunSnapshot(sessionId));
    return subscribeRun(sessionId, setSnap);
  }, [sessionId]);
  return useMemo(() => computeContextUsage(snap?.messages || [], model), [snap, model]);
}
